import { defineMessages } from 'react-intl';

export default defineMessages({
  folderNumber: {
    id: 'amc_details.my_refunds.folder_number',
  },
  status: {
    id: 'amc_details.my_refunds.status',
  },
  refundAmount: {
    id: 'amc_details.my_refunds.refund_amount',
  },
  reasonReject: {
    id: 'amc_details.my_refunds.reason_reject',
  },
  costs: {
    id: 'amc_details.my_refunds.costs',
  },
  Beneficiary: {
    id: 'amc_details.my_refunds.beneficiary',
  },
  aucunContenu: {
    id: 'amc_details.my_refunds.aucun_contenu',
  },
  lossDate: {
    id: 'amc_details.my_refunds.loss_date',
  },
  regulationDate: {
    id: 'amc_details.my_refunds.regulation_date',
  },
  claimNumber: {
    id: 'amc_details.my_refunds.claim_number',
  },
  regulationMode: {
    id: 'amc_details.my_refunds.regulation_mode',
  },
  rib: {
    id: 'amc_details.my_refunds.rib',
  },
  statusAgrement: {
    id: 'amc_details.my_refunds.status_agrement',
  },
  statusReturn: {
    id: 'amc_details.my_refunds.status_return',
  },
  statusVisite: {
    id: 'amc_details.my_refunds.status_visite',
  },
  statusRejected: {
    id: 'amc_details.my_refunds.status_rejected',
  },
  statusPaid: {
    id: 'amc_details.my_refunds.status_paid',
  },
  statusPecCanceled: {
    id: 'amc_details.my_refunds.status_pec_canceled',
  },
  statusPending: {
    id: 'amc_details.my_refunds.status_pending',
  },
  statusComplementaryInfo: {
    id: 'amc_details.my_refunds.status_complementary_info',
  },
  statusPec: {
    id: 'amc_details.my_refunds.status_pec',
  },
  statusSSuite: {
    id: 'amc_details.my_refunds.status_s_suite',
  },
  year: {
    id: 'suivi_sinistre.year',
  },
});
